/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/MoveToAnotherTreatment/Events/Content/Event/Appointment/Content/Status/Content"
  
}) {
let appointmentBookingStateValueData = fromData.useDataFormat({ viewPath,
context: 'appointment',
path: 'booking.state',
format: fromHelpers.getStatus,
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="appointment.booking.state"
 format="helpers.js getStatus"
 text={appointmentBookingStateValueData}
 color={dtColorsNeutral600}
/>
{children}
</React.Fragment>)
}